export default __webpack_public_path__ + "static/media/cars.b0a073f6.svg";